import styled from 'styled-components';

import { Sub2Typography } from '../Typography';

const StyledText = styled(Sub2Typography)`
  color: ${(props) => props.theme.colors.black};
`;

export default StyledText;
